import React, { useState } from "react";
import { motion } from "framer-motion";
import { Container, Row, Col, Form, Alert } from "react-bootstrap";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import emailjs from "@emailjs/browser";

function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    service: "",
    message: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setShowError(false);
    setErrorMessage("");

    try {
      await addDoc(collection(db, "contacts"), {
        type: "contact",

        name: formData.name,
        email: formData.email,
        company: formData.company,
        service: formData.service,
        message: formData.message,

        status: "new",

        timestamp: serverTimestamp()
      });

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID,
        {
          lead_type: "Contact",
          user_name: formData.name,
          company: formData.company,
          user_email: formData.email,
          message: formData.message
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_USER_TEMPLATE_ID,
        {
          lead_type: "Contact",

          user_name: formData.name,
          user_email: formData.email,

          company: formData.company,

          service: formData.service,

          message: formData.message
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setShowSuccess(true);

      setFormData({
        name: "",
        email: "",
        company: "",
        service: "",
        message: ""
      });

      setTimeout(() => {
        setShowSuccess(false);
      }, 6000);
    } catch (err) {
      console.error(err);

      setShowError(true);

      setErrorMessage(
        err.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };
    return (
    <div
      style={{
        background: "#ffffff",
        overflow: "hidden"
      }}
    >
      <section
        style={{
          background:
            "linear-gradient(180deg,#00152d 0%,#002147 100%)",
          padding: "140px 24px 110px",
          position: "relative"
        }}
      >
        <Container style={{ maxWidth: "1200px" }}>
          <Row className="align-items-center">
            <Col lg={7}>
              <motion.span
                initial={{
                  opacity: 0,
                  y: 20
                }}
                animate={{
                  opacity: 1,
                  y: 0
                }}
                style={{
                  color: "#21b573",
                  fontWeight: 700,
                  letterSpacing: "1px",
                  textTransform: "uppercase"
                }}
              >
                Contact EkritFly
              </motion.span>

              <motion.h1
                initial={{
                  opacity: 0,
                  y: 20
                }}
                animate={{
                  opacity: 1,
                  y: 0
                }}
                transition={{
                  delay: 0.1
                }}
                style={{
                  color: "#fff",
                  fontWeight: 700,
                  lineHeight: 1.05,
                  marginTop: "18px",
                  marginBottom: "24px",
                  fontSize:
                    "clamp(3rem,6vw,5.5rem)"
                }}
              >
                Let's Build
                <br />
                Your Next
                <br />
                Growth Phase.
              </motion.h1>

              <motion.p
                initial={{
                  opacity: 0,
                  y: 20
                }}
                animate={{
                  opacity: 1,
                  y: 0
                }}
                transition={{
                  delay: 0.2
                }}
                style={{
                  color:
                    "rgba(255,255,255,.78)",
                  maxWidth: "650px",
                  lineHeight: 1.9,
                  fontSize: "1.1rem"
                }}
              >
                Whether you need more
                visibility, qualified
                leads, stronger
                conversion rates or a
                modern digital presence,
                our team is ready to
                help.
              </motion.p>
            </Col>

            <Col lg={5}>
              <motion.div
                initial={{
                  opacity: 0,
                  x: 40
                }}
                animate={{
                  opacity: 1,
                  x: 0
                }}
                transition={{
                  delay: 0.3
                }}
                style={{
                  background:
                    "rgba(255,255,255,.05)",
                  border:
                    "1px solid rgba(255,255,255,.08)",
                  borderRadius: "32px",
                  padding: "36px",
                  backdropFilter:
                    "blur(14px)"
                }}
              >
                <div
                  style={{
                    color: "#fff",
                    fontSize: "1.25rem",
                    fontWeight: 700,
                    marginBottom: "24px"
                  }}
                >
                  Why Businesses Choose Us
                </div>

                {[
                  "Response within 24 hours",
                  "Strategy-first approach",
                  "Transparent execution",
                  "Long-term growth focus"
                ].map((item) => (
                  <div
                    key={item}
                    style={{
                      display: "flex",
                      gap: "12px",
                      marginBottom: "18px",
                      color:
                        "rgba(255,255,255,.82)"
                    }}
                  >
                    <span
                      style={{
                        color: "#21b573"
                      }}
                    >
                      ✓
                    </span>

                    {item}
                  </div>
                ))}
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
            <section
        style={{
          padding: "100px 24px"
        }}
      >
        <Container
          style={{
            maxWidth: "900px"
          }}
        >
          {showSuccess && (
            <Alert
              variant="success"
              style={{
                borderRadius: "18px",
                padding: "20px"
              }}
            >
              <strong>
                Message Received
              </strong>

              <div>
                We've received your
                request and sent a
                confirmation email.
              </div>
            </Alert>
          )}

          {showError && (
            <Alert
              variant="danger"
              style={{
                borderRadius: "18px"
              }}
            >
              {errorMessage}
            </Alert>
          )}

          <motion.div
            whileHover={{
              y: -4
            }}
            style={{
              background: "#fff",
              border:
                "1px solid rgba(0,33,71,.08)",
              borderRadius: "32px",
              padding: "48px",
              boxShadow:
                "0 20px 80px rgba(0,33,71,.08)"
            }}
          >
            <Form
              onSubmit={handleSubmit}
            >
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      Name *
                    </Form.Label>

                    <Form.Control
                      required
                      name="name"
                      value={
                        formData.name
                      }
                      onChange={
                        handleChange
                      }
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      Email *
                    </Form.Label>

                    <Form.Control
                      required
                      type="email"
                      name="email"
                      value={
                        formData.email
                      }
                      onChange={
                        handleChange
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-4">
                <Form.Label>
                  Company
                </Form.Label>

                <Form.Control
                  name="company"
                  value={
                    formData.company
                  }
                  onChange={
                    handleChange
                  }
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  Service *
                </Form.Label>

                <Form.Select
                  required
                  name="service"
                  value={
                    formData.service
                  }
                  onChange={
                    handleChange
                  }
                >
                  <option value="">
                    Select Service
                  </option>

                  <option>
                    Growth Strategy
                  </option>

                  <option>
                    SEO
                  </option>

                  <option>
                    Website Development
                  </option>

                  <option>
                    Performance Marketing
                  </option>

                  <option>
                    Marketing Automation
                  </option>

                  <option>
                    Growth Partnership
                  </option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>
                  Message *
                </Form.Label>

                <Form.Control
                  as="textarea"
                  rows={6}
                  required
                  name="message"
                  value={
                    formData.message
                  }
                  onChange={
                    handleChange
                  }
                />
              </Form.Group>

              <button
                type="submit"
                disabled={
                  isSubmitting
                }
                style={{
                  width: "100%",
                  height: "60px",
                  border: "none",
                  borderRadius:
                    "999px",
                  background:
                    "linear-gradient(135deg,#21b573,#002147)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize:
                    "1rem"
                }}
              >
                {isSubmitting
                  ? "Sending..."
                  : "Start The Conversation"}
              </button>
            </Form>
          </motion.div>
        </Container>
      </section>
    </div>
  );
}

export default ContactPage;